import React from 'react'
import GroupItem from './group-item/group-item.container'

const Groups = ({ groups, className }) => (
  <div className={className}>
    {groups.map(({ id }) => (
      <GroupItem key={id} id={id} />
    ))}
  </div>
)

export default Groups
